import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { MatChipInputEvent } from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { NotificationService, DataService, LoaderService, ErrorService, EVENTO, TYPEMESSAGE, UtilityService } from "../../../../shared/session/index";
import { SessionInfo } from "../../../../shared/session/SessionInfo";
import { IofficeAplicacion } from './../shared/officeAplicacion.model';

@Injectable()
export class officeAplicacionService {
  constructor(private dataService: DataService, private errorService: ErrorService, private notificationService: NotificationService,
    private loaderService: LoaderService, private utilityService: UtilityService, private sessionInfo: SessionInfo) { }

  asignarOfficeAplicacionUrl: string = 'officeAplicacion/insertar'
  deleteOfficeAplicacionUrl: string = 'officeAplicacion/delete'
  listarOfficesAllUrl: string = 'Office/listar'

  listOfficesAll() {
    this.dataService.set(this.listarOfficesAllUrl);
    return this.dataService.execGetJson();
  }
  toggleOfficeAcplicaion(OfficeID: number, AplicacionID: number, identificador: boolean) {
    let parameters: string;
    parameters = JSON.stringify({
      OfficeID: OfficeID,
      AplicacionID: AplicacionID,
    })

    if (identificador)
      this.dataService.set(this.asignarOfficeAplicacionUrl);
    else
      this.dataService.set(this.deleteOfficeAplicacionUrl);

    return this.dataService.execPostJson(parameters);
  }
}






